import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';

interface DetailSection1Props {
  submission: CreditSubmission;
}

export default function DetailSection1({ submission }: DetailSection1Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>1. Informasi Umum</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="text-sm text-gray-600">Jenis Permohonan</label>
            <p className="font-medium mt-1">{submission.application_type || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Sistem Kredit</label>
            <p className="font-medium mt-1">{submission.credit_system || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Jenis Debitur</label>
            <p className="font-medium mt-1">
              {submission.debtor_type === 'individual' ? 'Individu' : 'Korporasi'}
            </p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Wirausaha</label>
            <p className="font-medium mt-1">{submission.is_entrepreneur ? 'Ya' : 'Tidak'}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
